exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_Divider_1fcp02OsMl-7Ta99E24ocb {\n\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.IA_DividerHR_2gffPXPObCESzXSbhq6hfw {\n  height: 0;\n}", ""]);

// Exports
exports.locals = {
	"IA_Divider": "IA_Divider_1fcp02OsMl-7Ta99E24ocb",
	"IA_DividerHR": "IA_DividerHR_2gffPXPObCESzXSbhq6hfw"
};